/** Kannada UI strings (merged over English in translations.js). */
export const rawKn = {
  nav: {
    home: "ಮುಖಪುಟ",
    database: "ಸ್ಕ್ಯಾಮರ್ ಡೇಟಾಬೇಸ್",
    recovery: "ಪುನರ್‌ಪ್ರಾಪ್ತಿ ಪ್ರಕ್ರಿಯೆ",
    risk: "ಅಪಾಯ ಪರಿಶೀಲನೆ",
    redFlags: "ಕೆಂಪು ಸಂಕೇತಗಳು",
    education: "ಅರಿವು",
    stories: "ನಿಜವಾದ ಕಥೆಗಳು",
    about: "ನಮ್ಮ ಬಗ್ಗೆ",
    contact: "ಸಂಪರ್ಕ",
    legalHelp: "ಕಾನೂನು ಸಹಾಯ",
    reportCta: "ನಷ್ಟ ವರದಿ",
    mentors: "ಮೆಂಟರ್‌ಗಳು",
    dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    signIn: "ಸೈನ್ ಇನ್",
    signOut: "ಸೈನ್ ಔಟ್",
  },
  common: {
    reportScam: "ನಷ್ಟ ವರದಿ",
    learnRecovery: "ದೂರು ಪ್ರಕ್ರಿಯೆ ತಿಳಿಯಿರಿ",
    confidential: "೧೦೦% ಗೌಪ್ಯ",
    readMore: "ಇನ್ನಷ್ಟು ಓದಿ",
    backHome: "ಮುಖಪುಟಕ್ಕೆ ಹಿಂತಿರುಗಿ",
    search: "ಹುಡುಕಿ",
    verified: "ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
    anonymous: "ಅನಾಮಧೇಯ",
    submit: "ಸಲ್ಲಿಸಿ",
    cancel: "ರದ್ದು",
    requiredField: "ಅಗತ್ಯ",
    check: "ಈಗ ಪರಿಶೀಲಿಸಿ",
    loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
    error: "ಏನೋ ತಪ್ಪಾಗಿದೆ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  },
  hero: {
    eyebrow: "ಭಾರತದ ಪುರಾವೆ-ಆಧಾರಿತ ಆರ್ಥಿಕ ದೂರು ಮಾರ್ಗದರ್ಶನ",
    title1: "ಆರ್ಥಿಕ ನಷ್ಟದ ವಿರುದ್ಧ",
    title2: "ಹೋರಾಡಿ.",
    subtitle:
      "ಟ್ರೇಡಿಂಗ್ ವಂಚನೆಯಿಂದ ಬ್ಯಾಂಕಿಂಗ್, ಸೈಬರ್, ವಿಮೆ, ಏರ್‌ಲೈನ್, ಗ್ರಾಹಕ, ಹೌಸಿಂಗ್ ಫೈನಾನ್ಸ್ ಮತ್ತು ವೃತ್ತಿ ನಿಧಿ ವಿವಾದಗಳವರೆಗೆ — ಸರಿಯಾದ ಅಧಿಕಾರ, ಸರಿಯಾದ ಪುರಾವೆ ಮತ್ತು ಅಧಿಕೃತ ಭಾರತೀಯ ದೂರು ವ್ಯವಸ್ಥೆಯಲ್ಲಿ ಸರಿಯಾದ ಮುಂದಿನ ಹೆಜ್ಜೆ.",
    reportBtn: "ಆರ್ಥಿಕ ನಷ್ಟ ವರದಿ ಮಾಡಿ",
    recoveryBtn: "ದೂರು ಪ್ರಕ್ರಿಯೆ ತಿಳಿಯಿರಿ",
    taglines: ["ಸರಿಯಾದ ಅಧಿಕಾರ ಹುಡುಕಿ.", "ಸರಿಯಾದ ಪುರಾವೆ ಸಿದ್ಧಪಡಿಸಿ.", "ಸರಿಯಾದ ಹೆಜ್ಜೆ ತೆಗೆದುಕೊಳ್ಳಿ."],
  },
  report: {
    title: "ಅನಾಮಧೇಯವಾಗಿ ವರದಿ ಮಾಡಿ",
    subtitle: "ನಿಮ್ಮ ಗುರುತು ಸಂಪೂರ್ಣ ಗೌಪ್ಯ. ಪ್ರಕಟಿಸುವ ಮೊದಲು ಪ್ರತಿ ವರದಿ ಪರಿಶೀಲಿಸಲಾಗುತ್ತದೆ.",
    scamType: "ನಷ್ಟದ ಪ್ರಕಾರ",
    amountLost: "ನಷ್ಟದ ಮೊತ್ತ (₹)",
    platform: "ಬಳಸಿದ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್",
    telegram: "ಟೆಲಿಗ್ರಾಮ್ ಯೂಸರ್‌ನೇಮ್ (ಇದ್ದರೆ)",
    upi: "UPI ID (ಇದ್ದರೆ)",
    phone: "ಫೋನ್ ಸಂಖ್ಯೆ (ಇದ್ದರೆ)",
    company: "ಕಂಪನಿ / ಸಲಹೆಗಾರರ ಹೆಸರು",
    website: "ವೆಬ್‌ಸೈಟ್ URL",
    description: "ಏನಾಯಿತು — ವಿವರವಾಗಿ ಬರೆಯಿರಿ",
    contact: "ಇಮೇಲ್ (ಐಚ್ಛಿಕ)",
    uploadEvidence: "ಪುರಾವೆ ಅಪ್‌ಲೋಡ್",
    uploadHelp: "ಸ್ಕ್ರೀನ್‌ಶಾಟ್, PDF, ಪಾವತಿ ಪುರಾವೆ, ಚಾಟ್ ಎಕ್ಸ್‌ಪೋರ್ಟ್. ಫೈಲ್‌ಗೆ ೧೦MB.",
    submit: "ಸುರಕ್ಷಿತವಾಗಿ ಸಲ್ಲಿಸಿ",
    successTitle: "ವರದಿ ಸಲ್ಲಿಸಲಾಗಿದೆ",
    successDesc: "ಧನ್ಯವಾದ. ೭೨ ಗಂಟೆಗಳಲ್ಲಿ ನಮ್ಮ ತಂಡ ಪುರಾವೆ ಪರಿಶೀಲಿಸುತ್ತದೆ. ನಿಮ್ಮ ಗುರುತು ಗೌಪ್ಯವಾಗಿರುತ್ತದೆ.",
    disclaimer: "ಪ್ರತಿ ಆರೋಪಕ್ಕೆ ಪುರಾವೆ ಅಗತ್ಯ. ಸುಳ್ಳು ವರದಿಗಳನ್ನು ತಿರಸ್ಕರಿಸಬಹುದು.",
  },
  education: {
    eyebrow: "ಕಲಿ · ರಕ್ಷಣೆ · ಪುನರ್‌ಪ್ರಾಪ್ತಿ",
    title: "ಅರಿವು ಕೇಂದ್ರ",
    subtitle: "ಭಾರತೀಯ ಹೂಡಿಕೆದಾರರಿಗೆ ವಂಚನೆ ಅರಿವು ಮತ್ತು ಕಾನೂನು ಮಾರ್ಗದರ್ಶನ.",
    readMinutes: "ನಿಮಿಷ ಓದಿ",
    filterAll: "ಎಲ್ಲಾ",
    emptyCategory: "ಈ ವರ್ಗದಲ್ಲಿ ಇನ್ನೂ ಲೇಖನಗಳಿಲ್ಲ.",
  },
  blog: {
    eyebrow: "ತನಿಖೆ · ಕಥೆಗಳು · ಮಾರ್ಗದರ್ಶಿ",
    title: "ಬ್ಲಾಗ್ — ನಿಜ ಪ್ರಕರಣಗಳು, ಕಾನೂನು ಮಾರ್ಗ",
    subtitle: "ಪರಿಶೀಲಿಸಿದ ಬಲಿ ಹೇಳಿಕೆಗಳು ಮತ್ತು ಕಾನೂನು ದೂರು ಹಂತಗಳು.",
    allStories: "ಎಲ್ಲಾ ಕಥೆಗಳು",
    featured: "ವಿಶೇಷ",
    readFull: "ಪೂರ್ಣ ಓದಿ",
    readArticle: "ಪೂರ್ಣ ಲೇಖನ",
    collapse: "ಸಂಕುಚಿಸಿ",
    emptyCategory: "ಈ ವರ್ಗದಲ್ಲಿ ಇನ್ನೂ ಲೇಖನಗಳಿಲ್ಲ.",
    newBadge: "ಹೊಸ",
  },
  footer: {
    tagline: "ಗುಜ್ಜು ಅಲ್ಲ, ಪುರಾವೆ. ಮೌನ ಅಲ್ಲ, ಸುರಕ್ಷತೆ.",
    sections: { platform: "ಪ್ಲಾಟ್‌ಫಾರ್ಮ್", legal: "ಕಾನೂನು", connect: "ಸಂಪರ್ಕ" },
    links: {
      privacy: "ಗೌಪ್ಯತೆ ನೀತಿ",
      terms: "ಬಳಕೆಯ ನಿಯಮಗಳು",
      disclaimer: "ಹಕ್ಕು ನಿರಾಕರಣೆ",
      antiHarassment: "ಕಿರುಕುಳ ನಿರೋಧ ನೀತಿ",
      dataDeletion: "ಡೇಟಾ ಅಳಿಸುವಿಕೆ",
    },
    disclaimer: "CHINTAMAT ಆರ್ಥಿಕ ಸಲಹೆ ನೀಡುವುದಿಲ್ಲ. ಪುನರ್‌ಪ್ರಾಪ್ತಿಗೆ guarantee ನೀಡುವುದಿಲ್ಲ.",
    rights: "© ೨೦೨೬ CHINTAMAT. ಸಾರ್ವಜನಿಕ ಹಿತದ ವಂಚನೆ-ವಿರೋಧಿ ಮಿಷನ್.",
  },
  stats: {
    reports: "ಪರಿಶೀಲಿಸಿದ ದೂರುಗಳು",
    scammers: "ಟ್ರ್ಯಾಕ್ ಮಾಡಿದ ವಂಚಕರು",
    cases: "ಪರಿಹರಿಸಿದ ಪ್ರಕರಣಗಳು",
    loss: "ವರದಿಯಾದ ನಷ್ಟ",
  },
};

export const appStringsKn = {
  lang: { choose: "ಭಾಷೆ ಆಯ್ಕೆಮಾಡಿ" },
  auth: {
    welcomeBack: "ಮತ್ತೆ ಸ್ವಾಗತ",
    signInSubtitle: "ವಿಮರ್ಶೆ, ಕೇಸ್ ಟ್ರ್ಯಾಕ್ ಮತ್ತು ಮೆಂಟರ್ ಉಳಿಸಲು ಸೈನ್ ಇನ್ ಮಾಡಿ.",
    joinTitle: "CHINTAMAT ಗೆ ಸೇರಿ",
    joinSubtitle: "ಸ್ಕ್ಯಾಮ್ ವರದಿ, ಕಾನೂನು ಸಹಾಯ ಮತ್ತು ಮೆಂಟರ್ ಡೈರೆಕ್ಟರಿಗೆ ಖಾತೆ ತೆರೆಯಿರಿ.",
    email: "ಇಮೇಲ್",
    password: "ಪಾಸ್‌ವರ್ಡ್",
    name: "ಪೂರ್ಣ ಹೆಸರು",
    signIn: "ಸೈನ್ ಇನ್",
    signUp: "ಖಾತೆ ತೆರೆಯಿರಿ",
    continueGoogle: "Google ನೊಂದಿಗೆ ಮುಂದುವರಿಸಿ",
    orEmail: "ಅಥವಾ ಇಮೇಲ್",
    newHere: "CHINTAMAT ನಲ್ಲಿ ಹೊಸಬರೇ?",
    haveAccount: "ಈಗಾಗಲೇ ಖಾತೆ ಇದೆಯೇ?",
    createAccount: "ಖಾತೆ ತೆರೆಯಿರಿ",
    gotoSignIn: "ಸೈನ್ ಇನ್",
    passwordMin: "ಪಾಸ್‌ವರ್ಡ್ ಕನಿಷ್ಠ ೬ ಅಕ್ಷರಗಳು",
    roleUser: "ವೈಯಕ್ತಿಕ",
    roleUserDesc: "ಟ್ರೇಡರ್ / ಬಲಿ — ವರದಿ ಅಥವಾ ಸಂಶೋಧನೆಗಾಗಿ.",
    roleMentor: "ಮೆಂಟರ್ / ಶಿಕ್ಷಕ",
    roleMentorDesc: "ಕೋರ್ಸ್, ಚಾನೆಲ್ ಅಥವಾ ಪೇಯ್ಡ್ ಮೆಂಟರ್‌ಶಿಪ್ ನಡೆಸುತ್ತೇನೆ.",
    roleAdvisory: "ಸಂಶೋಧನಾ ವಿಶ್ಲೇಷಕ / ಸಲಹೆ",
    roleAdvisoryDesc: "SEBI ನೋಂದಾಯಿತ RIA, RA ಅಥವಾ ಸಂಸ್ಥೆ.",
    verifying: "ಸೆಷನ್ ಪರಿಶೀಲನೆ…",
    adminRequired: "ಅಡ್ಮಿನ್ ಪ್ರವೇಶ ಅಗತ್ಯ.",
  },
  dashboard: {
    eyebrow: "ನನ್ನ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    hello: "ನಮಸ್ಕಾರ",
    adminPanel: "ಅಡ್ಮಿನ್ ಪ್ಯಾನೆಲ್",
    adminDesc: "ಬಳಕೆದಾರರು, ಸ್ಕ್ಯಾಮ್ ವರದಿಗಳು, ಕಾನೂನು ಸಹಾಯ ಮತ್ತು ಬ್ಲಾಗ್ ನಿರ್ವಹಿಸಿ.",
    openAdmin: "ಅಡ್ಮಿನ್ ತೆರೆಯಿರಿ",
    statReviews: "ಬರೆದ ವಿಮರ್ಶೆಗಳು",
    statCases: "ವರದಿ ಮಾಡಿದ ಕೇಸ್‌ಗಳು",
    statLegal: "ಕಾನೂನು ವಿನಂತಿಗಳು",
    statSaved: "ಉಳಿಸಿದ ಮೆಂಟರ್‌ಗಳು",
    tabReviews: "ನನ್ನ ವಿಮರ್ಶೆಗಳು",
    tabCases: "ನನ್ನ ಕೇಸ್‌ಗಳು",
    tabSaved: "ಉಳಿಸಿದ ಮೆಂಟರ್‌ಗಳು",
    tabLegal: "ಕಾನೂನು ಸಹಾಯ",
    emptyReviews: "ಇನ್ನೂ ವಿಮರ್ಶೆಗಳಿಲ್ಲ.",
    browseMentors: "ಮೆಂಟರ್‌ಗಳನ್ನು ನೋಡಿ",
    emptyCases: "ಇನ್ನೂ ಕೇಸ್‌ಗಳಿಲ್ಲ.",
    reportScam: "ನಷ್ಟ ವರದಿ",
    emptySaved: "ಉಳಿಸಿದ ಮೆಂಟರ್‌ಗಳಿಲ್ಲ.",
    discoverMentors: "ಮೆಂಟರ್‌ಗಳನ್ನು ಹುಡುಕಿ",
    emptyLegal: "ಇನ್ನೂ ಕಾನೂನು ವಿನಂತಿಗಳಿಲ್ಲ.",
    submitLegal: "ವಿನಂತಿ ಕಳುಹಿಸಿ",
    viewProfile: "ಪ್ರೊಫೈಲ್",
    recentActivity: "ಇತ್ತೀಚಿನ ನವೀಕರಣಗಳು",
    openCase: "ಕೇಸ್ ತೆರೆಯಿರಿ",
    prefsTitle: "ಅಧಿಸೂಚನೆ ಆದ್ಯತೆಗಳು",
    prefsBlog: "ಹೊಸ ಬ್ಲಾಗ್ ಮತ್ತು ಶಿಕ್ಷಣ ಲೇಖನಗಳು",
    prefsCase: "ಕೇಸ್ ಸ್ಥಿತಿ ಮತ್ತು ಸ್ಟಾಫ್ ಉತ್ತರ",
    prefsSaved: "ಆದ್ಯತೆಗಳು ಉಳಿಸಲಾಗಿದೆ",
  },
  notifications: {
    title: "ಅಧಿಸೂಚನೆಗಳು",
    empty: "ಇನ್ನೂ ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ",
    markAllRead: "ಎಲ್ಲವನ್ನೂ ಓದಿದೆ ಎಂದು ಗುರುತಿಸಿ",
    viewDashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ತೆರೆಯಿರಿ",
    types: {
      case_status_change: { title: "{caseLabel} — ಸ್ಥಿತಿ ನವೀಕರಣ", body: "ನಿಮ್ಮ ಕೇಸ್ ಈಗ: {status}" },
      case_staff_comment: { title: "CHINTAMAT ನಿಂದ ಉತ್ತರ", body: "{authorName}: {preview}" },
      case_user_comment: { title: "ಬಳಕೆದಾರ ಟಿಪ್ಪಣಿ — {caseLabel}", body: "{authorName}: {preview}" },
      new_scam_report: { title: "ಹೊಸ ಸ್ಕ್ಯಾಮ್ ವರದಿ", body: "{scamType}" },
      new_legal_request: { title: "ಹೊಸ ಕಾನೂನು ವಿನಂತಿ", body: "{lossType} — {name}" },
      blog_published: { title: "ಹೊಸ ಲೇಖನ", body: "{articleTitle}" },
    },
  },
  caseWorkspace: {
    evidenceTitle: "ಪುರಾವೆ ಪಟ್ಟಿ",
    statusTimeline: "ಸ್ಥಿತಿ ಕಾಲರೇಖೆ",
    comments: "ಟಿಪ್ಪಣಿಗಳು",
    sendMessage: "ಸಂದೇಶ ಕಳುಹಿಸಿ",
    postComment: "ಟಿಪ್ಪಣಿ ಪೋಸ್ಟ್",
    noComments: "ಇನ್ನೂ ಟಿಪ್ಪಣಿಗಳಿಲ್ಲ. CHINTAMAT ಸ್ಟಾಫ್ ಇಲ್ಲಿ ಉತ್ತರಿಸುತ್ತಾರೆ.",
    userCommentHint: "ನಿಮ್ಮ ಸಂದೇಶ CHINTAMAT ಸ್ಟಾಫ್‌ಗೆ ಕಾಣಿಸುತ್ತದೆ.",
    staffCommentHint: "ಸಾರ್ವಜನಿಕ ಟಿಪ್ಪಣಿಗಳು ಬಳಕೆದಾರರಿಗೆ ಕಾಣುತ್ತವೆ. ಆಂತರಿಕ ಟಿಪ್ಪಣಿಗಳು ಸ್ಟಾಫ್‌ಗೆ ಮಾತ್ರ.",
    publicVis: "ಸಾರ್ವಜನಿಕ (ಬಳಕೆದಾರ ನೋಡಬಹುದು)",
    internalVis: "ಆಂತರಿಕ ಮಾತ್ರ",
    loading: "ಕೇಸ್ ಲೋಡ್…",
    notFound: "ಕೇಸ್ ಕಂಡುಬಂದಿಲ್ಲ",
    caseUpdated: "ಕೇಸ್ ನವೀಕರಿಸಲಾಗಿದೆ",
    commentPosted: "ಟಿಪ್ಪಣಿ ಪೋಸ್ಟ್ ಆಯಿತು",
    checklist: {
      screenshots: "ಚಾಟ್ ಅಥವಾ ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ಪುರಾವೆ",
      payment_proof: "UPI / ಬ್ಯಾಂಕ್ ಪಾವತಿ ಪುರಾವೆ",
      platform_profile: "ವಂಚಕ ಪ್ರೊಫೈಲ್ ಲಿಂಕ್‌ಗಳು",
      contract: "ಇನ್‌ವಾಯ್ಸ್ ಅಥವಾ ಒಪ್ಪಂದ",
    },
  },
  mentors: {
    title: "ಮೆಂಟರ್ ಡೈರೆಕ್ಟರಿ",
    subtitle: "ಪಾವತಿಗೆ ಮೊದಲು ಮೆಂಟರ್‌ಗಳನ್ನು ಪರಿಶೀಲಿಸಿ. ವಿಮರ್ಶೆಗಳು ನೋಂದಾಯಿತ ಬಳಕೆದಾರರಿಂದ — SEBI ನೋಂದಣಿ ಸ್ವತಂತ್ರವಾಗಿ ಪರಿಶೀಲಿಸಿ.",
    search: "ಹೆಸರು, ಕಂಪನಿ, ನಗರ ಹುಡುಕಿ…",
    category: "ವರ್ಗ",
    allCategories: "ಎಲ್ಲಾ ವರ್ಗಗಳು",
    verification: "ಪರಿಶೀಲನೆ",
    all: "ಎಲ್ಲಾ",
    verifiedOnly: "ಪರಿಶೀಲಿಸಿದವು ಮಾತ್ರ",
    unverified: "ಪರಿಶೀಲಿಸದ",
    sortTrust: "ಅತ್ಯಧಿಕ ವಿಶ್ವಾಸ",
    sortReviews: "ಅತ್ಯಧಿಕ ವಿಮರ್ಶೆಗಳು",
    sortRecent: "ಇತ್ತೀಚಿನ",
    noResults: "ಮೆಂಟರ್‌ಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    viewProfile: "ಪ್ರೊಫೈಲ್",
    reviews: "ವಿಮರ್ಶೆಗಳು",
  },
  protected: { loading: "ಸೆಷನ್ ಪರಿಶೀಲನೆ…", adminLoading: "ಅಡ್ಮಿನ್ ಪರಿಶೀಲನೆ…" },
};
